<template>
  <vx-card no-shadow :title="tittle">
    <!-- <span>Recuerda no utilizar <strong>caracteres especiales</strong>.</span> -->
    <label class="vs-input--label">{{$t(`CONECCTIONSVIEW.company`)}}:</label>
    <v-select
      class="mb-2"
      :reduce="name => name"
      v-model="connection.company"
      label="name"
      :clearable="false"
      :options="connList"
      v-validate="'required'"
      name="companyID"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />

    <label class="vs-input--label">{{$t(`CONECCTIONSVIEW.typeConnection`)}}</label>
    <v-select
      class="mb-2"
      :reduce="name => name.id"
      v-model="connection.type"
      label="name"
      :clearable="false"
      :options="typeConnections"
      v-validate="'required'"
      name="typeID"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />

    <label class="vs-input--label">{{$t(`CONECCTIONSVIEW.motorConnection`)}}</label>
    <v-select
      class="mb-2"
      :reduce="({name}) => name"
      v-model="connection.driver"
      label="name"
      :clearable="false"
      :options="driverList"
      v-validate="'required'"
      name="driverID"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />

    <!-- <vs-input class="w-full mb-base" label-placeholder="driver" v-model="driver"></vs-input> -->

    <vs-input class="w-full mb-2" :label="$t(`CONECCTIONSVIEW.nameConnection`)" v-model="connection.name"></vs-input>
    <vs-input class="w-full mb-2" :label="$t(`CONECCTIONSVIEW.user`)" v-model="connection.username"></vs-input>

    <div class="mb-2">
      <label class="vs-input--label">{{$t(`CONECCTIONSVIEW.password`)}}:</label>
      <vx-input-group>
        <vs-input :type="typeInput" class="w-full" v-model="connection.password"></vs-input>

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button color="primary" type="border" @click="eye = !eye">
              <feather-icon :icon="EyeIcon" svgClasses="w-5 h-5" />
            </vs-button>
          </div>
        </template>
      </vx-input-group>
    </div>

    <vs-input class="w-full mb-6" :label="$t(`CONECCTIONSVIEW.dataBase`)" v-model="connection.database"></vs-input>

    <div v-if="type === 'custom'">
      <vs-input class="w-full mb-2" :label="$t(`CONECCTIONSVIEW.host`)" v-model.trim="connection.host"></vs-input>
    </div>

    <div v-if="type === 'cloudsql'">
      <div class="mb-3" :key="radio">
        <vs-radio class="mr-5" v-model="radio" vs-value="host">{{$t(`CONECCTIONSVIEW.host`)}}</vs-radio>
        <vs-radio v-model="radio" vs-value="projectID">{{$t(`CONECCTIONSVIEW.idProject`)}}</vs-radio>
      </div>

      <div v-if="radio === 'host'">
        <vs-input class="w-full mb-base" :label="$t(`CONECCTIONSVIEW.host`)" v-model.trim="connection.host"></vs-input>
      </div>
      <div class="mt-3" v-if="radio === 'projectID'">
        <vs-input class="w-full mb-2" :label="$t(`CONECCTIONSVIEW.idProjectGCP`)" v-model="connection.projectID"></vs-input>
        <vs-input
          class="w-full mb-2"
          :label="$t(`CONECCTIONSVIEW.nameInstance`)"
          :placeholder="$t(`CONECCTIONSVIEW.examplePlaceHolder`)"
          v-model="connection.instanceName"
        ></vs-input>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button 
      v-if="isEditing" 
      class="ml-auto mt-2" type="border" color="success" @click="updateConn"
        >{{$t(`CONECCTIONSVIEW.update`)}}</vs-button>
      <vs-button v-else class="ml-auto mt-2" type="border" color="success" @click="saveChanges">{{$t(`CONECCTIONSVIEW.create`)}}</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="danger" >Restablecer</vs-button> -->
      <vs-button
        v-if="isEditing"
        class="ml-4 mt-2"
        type="border"
        color="rgb(62, 201, 214)"
        @click="getDataToUpdate(connEdit)"
        >{{$t(`CONECCTIONSVIEW.restore`)}}</vs-button
      >
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelChanges">{{$t(`CONECCTIONSVIEW.cancel`)}}</vs-button>
    </div>
  </vx-card>
</template>

<script>
import * as Connections from "./Connections";
import { getAllCompanies } from "../Companies/Companies";
import vSelect from "vue-select";
import { notify } from "@/helpers/$vs.js";
import Utils from "@/helpers/Utils";

export default {
  props: {
    connEdit: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      radio: null,
      eye: true,
      connList: [],
      driverList: [{ name: "mysql" }, { name: "postgresql" }],
      typeConnections: [
        { id: "cloudsql", name: "Sql en la nube" },
        { id: "custom", name: "Personalizado" }
      ],
      optList: null,
      connection: {
        company: null,
        type: null,
        name: null,
        driver: null,       
        username: null,
        password: null,
        database: null,
        host: null,
        projectID: null,
        instanceName: null,
        isEdit: false
      }
    };
  },
  components: {
    vSelect
  },
  watch: {
    radio() {
      if (!this.isEdit) {
        this.clearHostProjectID();
      }
      this.isEdit = false;
    },
    connEdit(value) {
      this.getDataToUpdate(value);
    }
  },
  methods: {
    sendMessageToUpdateList() {
      this.$root.$emit("UPDATE_CONNECTION_LIST", {});
    },
    validateData() {
      if (this.connection.company === null || this.connection.company === undefined) {
        this.$vs.notify({
          title: "Gestor de Conexiones",
          text: "Selecciona una Compañia para continuar",
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (!this.isEditing && (this.connection.type === null || this.connection.type === undefined)) {
        this.$vs.notify({
          title: "Tipo de conexión",
          text: "Selecciona un tipo de conexión",
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (!this.isEditing && (this.connection.driver === null || this.connection.driver === undefined)) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.managerConnection`),
          text: this.$t(`CONECCTIONSVIEW.selectMotorConnection`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (!this.isEditing && (this.connection.name === null || this.connection.name === undefined || this.connection.name.length <= 0)) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.managerConnection`),
          text: this.$t(`CONECCTIONSVIEW.enterNameConnecction`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (!this.isEditing && this.connection.name.length < 3) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.manageKeys`),
          text:  this.$t(`CONECCTIONSVIEW.validateNameConnection`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (
        !this.isEditing &&
        (this.connection.username === null ||
        this.connection.username === undefined ||
        this.connection.username.length <= 3)
      ) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.manageKeys`),
          text: this.$t(`CONECCTIONSVIEW.validateNameUser`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (
        !this.isEditing &&
        (this.connection.password === null ||
        this.connection.password === undefined ||
        this.connection.password.length < 6)
      ) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.manageKeys`),
          text: this.$t(`CONECCTIONSVIEW.validateKeys`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (
        !this.isEditing &&
        (this.connection.database === null ||
        this.connection.database === undefined ||
        this.connection.database.length < 3)
      ) {
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.manageKeys`),
          text: this.$t(`CONECCTIONSVIEW.validateNameDB`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (this.connection.type === "custom") {
        if (!this.isEditing && (this.connection.host === null || this.connection.host === undefined)) {
          this.$vs.notify({
            title: this.$t(`CONECCTIONSVIEW.host`),
            text: this.$t(`CONECCTIONSVIEW.enterIpHost`),
            color: "warning",
            icon: "error",
            time: 4000
          });
          return false;
        }
      } else if (this.connection.host !== null && this.connection.host !== undefined && this.connection.host.trim() !== '') {
        if (!Utils.isIp(this.connection.host)) {
          this.$vs.notify({
            title: this.$t(`CONECCTIONSVIEW.host`),
            text: this.$t(`CONECCTIONSVIEW.validateIpHost`), 
            color: "warning",
            icon: "error",
            time: 4000
          });
          return false;
        }
      } else {
        if (this.radio === null) {
          this.$vs.notify({
            title: this.$t(`CONECCTIONSVIEW.pahtConnection`),
            text: this.$t(`CONECCTIONSVIEW.selectFormConecction`),
            color: "warning",
            icon: "error",
            time: 4000
          });
          return false;
        }

        if (this.radio === "host") {
          if (this.connection.host === null || this.connection.host === undefined) {
            this.$vs.notify({
              title: this.$t(`CONECCTIONSVIEW.host`),
              text: this.$t(`CONECCTIONSVIEW.enterIpHost`),
              color: "warning",
              icon: "error",
              time: 4000
            });
            return false;
          }
        } else if (this.radio === "projectID") {
          if (
            this.connection.projectID === null ||
            this.connection.projectID === undefined ||
            this.connection.projectID.length < 6
          ) {
            this.$vs.notify({
              title: this.$t(`CONECCTIONSVIEW.nameProject`),
              text: this.$t(`CONECCTIONSVIEW.validateIdProyect`),
              color: "warning",
              icon: "error",
              time: 4000
            });
            return false;
          }
          if (
            this.connection.instanceName === null ||
            this.connection.instanceName === undefined ||
            this.connection.instanceName.length < 4
          ) {
            this.$vs.notify({
              title: this.$t(`CONECCTIONSVIEW.nameInstance`),
              text: this.$t(`CONECCTIONSVIEW.validateInstane`),
              color: "warning",
              icon: "error",
              time: 4000
            });
            return false;
          }
        }
      }

      return true;
    },
    mapData() {
      let data = null;
      if (this.connection.type === "custom") {
        data = [this.connection].map(conn => ({
          companyID: conn.company.key,
          type: conn.type,
          driver: conn.driver,
          name: conn.name,
          user: conn.username,
          password: conn.password,
          database: conn.database,
          host: conn.host
        }))[0];
      } else {
        if (this.radio === "host") {
          data = [this.connection].map(conn => ({
            companyID: conn.company.key,
            type: conn.type,
            driver: conn.driver,
            name: conn.name,
            username: conn.username,
            password: conn.password,
            database: conn.database,
            host: conn.host
          }))[0];
        } else if (this.radio === "projectID") {
          data = [this.connection].map(conn => ({
            companyID: conn.company.key,
            type: conn.type,
            driver: conn.driver,
            name: conn.name,
            username: conn.username,
            password: conn.password,
            database: conn.database,
            projectID: conn.projectID,
            instanceName: conn.instanceName
          }))[0];
        }
      }

      return data;
    },
    async saveChanges() {

      if(!this.validateData()) return;
      const  data = this.mapData();
      this.$vs.loading({ type: "sound" });
      try {
        await Connections.saveConnection(data);
        this.$vs.notify({
          title: "Gestor de Conexiones",
          text: "Conexion creada con exito!",
          iconPack: "feather",
          icon: "icon-bell",
          color: "primary",
          time: 6000
        });

        this.sendMessageToUpdateList();
        this.cancelChanges();
      } catch (error) {
        console.error("saveConnection error", error);
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.managerConnection`),
          text: this.$t(`CONECCTIONSVIEW.errorSaveConnection`, {error: error.message}),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    mapDataUpdate() {
      let data = {};
      for(let i in this.connection) {
        if(i === 'company') continue;
        if(this.connection[i] !== null && this.connection[i] !== undefined && this.connection[i].trim() !== '') {
          data[i] = this.connection[i];
        }             
      }
      data.companyID = this.connection.company.key;
      return data;
    },
    async updateConn() {
      if(!this.validateData()) return;
      const  data = this.mapDataUpdate();
      this.$vs.loading({ type: "sound" });     

      try {
        await Connections.updateConnection(this.connEdit.key, data);
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.managerConnection`),
          text: this.$t(`CONECCTIONSVIEW.updateConnection`),
          iconPack: "feather",
          icon: "icon-bell",
          color: "primary",
          time: 6000
        });

        this.sendMessageToUpdateList();
        this.cancelChanges();
        this.$emit("cleanData");
      } catch (error) {
        console.error("saveConnection error", error);
        this.$vs.notify({
          title: this.$t(`CONECCTIONSVIEW.managerConnection`),
          text: this.$t(`CONECCTIONSVIEW.errorSaveConnection`, {error: error.message}),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }

    },
    cancelChanges() {
      this.connection = {
        company: null,
        type: null,
        driver: null,
        conn: null,
        username: null,
        password: null,
        dbname: null,
        host: null,
        projectID: null,
        instanceName: null
      };
      this.$emit("cleanData");
    },
    clearHostProjectID() {
      this.connection.host = null;
      this.connection.projectID = null;
      this.connection.instanceName = null;
    },
    async getAllConnections() {
      this.$vs.loading({ type: "sound" });
      try {
        const result = await getAllCompanies();
        this.connList = result.filter(conn => conn.status === "Active").map(({ key, name }) => ({ key, name }));
      } catch (error) {
        console.error("Companies Error:", error);
        const message = error.error ? error.error : `(${error.message})`;
        let text = "";
        if (message === "Connections are empty") text = this.$t(`CONECCTIONSVIEW.emptyCompanies`);
        notify(this.$t(`CONECCTIONSVIEW.listCompanies`), text, "warning");
      } finally {
        this.$vs.loading.close();
      }
    },
    getDataToUpdate(value) {
      this.isEdit = true;
      this.connection = {
        company: { key: value.companyID, name: value.companyName },
        type: value.connType,
        driver: value.driver,
        name: value.name,
        username: value.username,
        password: value.password,
        database: value.database,
        host: value.host,
        projectID: value.projectID,
        instanceName: value.instanceName
      };

      if (value.projectID !== null) {
        this.radio = "projectID";

        this.connection.projectID = value.projectID;
        this.connection.instanceName = value.instanceName;
      } else {
        this.radio = "host";
        this.connection.host = value.host;
      }
    }
  },
  mounted() {
    if(this.isEditing) this.getDataToUpdate(this.connEdit);
    this.getAllConnections();
  },
  computed: {
    EyeIcon() {
      return this.eye ? "EyeOffIcon" : "EyeIcon";
    },
    type() {
      return this.connection.type;
    },
    typeInput() {
      return this.eye ? "password" : "text";
    },
    isEditing() {
      return this.connEdit.key !== null;
    },
    tittle() {
      return this.isEditing?this.$t(`CONECCTIONSVIEW._updateConnection`):this.$t(`CONECCTIONSVIEW._newConnection`);
    }
  }
};
</script>
